var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// ダッシュボード
import React, { useState, useEffect, useMemo } from 'react';
import { render } from 'react-dom';
import axios from '../axios';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { Row } from 'react-bootstrap';
// 案件一覧のURL
var reception_list_base_url = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/list";
var DashboardIndex = function () {
    var _a = useState(false), is_loading = _a[0], setIsLoading = _a[1];
    var _b = useState([]), reception_info = _b[0], setReception = _b[1];
    var _c = useState(), error_message = _c[0], setErrorMessage = _c[1];
    var _d = useState(''), header_message = _d[0], setHeaderMessage = _d[1];
    var _e = useState([]), news = _e[0], setNews = _e[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getReception = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        return [4 /*yield*/, axios.get('staff/dashboard/list_count')];
                    case 1:
                        response = _a.sent();
                        setReception(response.data.info);
                        setNews(response.data.news);
                        setHeaderMessage(response.data.header_message);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        setErrorMessage(error_1.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 案件情報を取得
        getReception();
    }, []);
    // 案件一覧へ戻るボタンのクリックイベントハンドラ
    var handleClick = function () {
        location.replace(reception_list_base_url);
    };
    // 不要なレンダリング防止のためにuseMemoで表示情報を取得する
    var setDisplayInfo = function () {
        var display_info = useMemo(function () { return createStatusBlockElement(); }, [reception_info]);
        return display_info;
    };
    // 表示情報生成(ループ処理)
    var createStatusBlockElement = function () {
        return Object.values(reception_info).map(function (status_group_list) {
            // ステータスグループ
            return Object.values(status_group_list).map(function (status_group, index) {
                // 行単位
                return Object.values(status_group).map(function (group) {
                    // 案件ステータス
                    return createElement(group, index);
                });
            });
        });
    };
    // ステータスグループと案件情報のエレメント生成
    var createElement = function (group, index) {
        return (
        // Indexを使用しユニークなkey文字列を生成する
        React.createElement("div", { key: group.status_group_index + "-" + index, className: "box py-3" },
            React.createElement("fieldset", { className: "border border-primary status-width mx-2" },
                React.createElement("legend", { className: "w-auto px-3 ml-3" }, group.group_name),
                createReceptionElement(group.reception)),
            React.createElement("div", { className: "px-5" })));
    };
    // 案件情報のエレメント生成
    var createReceptionElement = function (reception) {
        var reception_list_search_url_all_count = reception_list_base_url;
        var reception_list_search_url_stay_count = reception_list_base_url;
        var query_string_all_count = '';
        var query_string_stay_count = '';
        return (React.createElement("div", { className: "py-3" },
            React.createElement("div", { className: "row px-5" },
                React.createElement("div", { className: "col-lg-7 ml-3" }, "\u72B6\u614B"),
                React.createElement("div", { className: "col-sm-2 ml-3 text-center" }, "\u6848\u4EF6\u6570"),
                React.createElement("div", { className: "col-sm-2 ml-3 text-center" }, "\u6EDE\u7559\u6570")),
            Object.values(reception).map(function (reception_row) {
                // 案件一覧のURLを生成
                // TODO 案件の更新日を検索パラメータにセットする。(お客様に確認中)
                query_string_all_count =
                    '?status_from=' + reception_row.status + '&status_to=' + reception_row.status;
                reception_list_search_url_all_count = reception_list_base_url + query_string_all_count;
                query_string_stay_count =
                    '?status_from=' +
                        reception_row.status +
                        '&status_to=' +
                        reception_row.status +
                        '&is_stay=true';
                reception_list_search_url_stay_count = reception_list_base_url + query_string_stay_count;
                return (React.createElement(React.Fragment, { key: reception_row.reception_status_index },
                    React.createElement("div", { className: "pt-2" }),
                    React.createElement("div", { className: "row px-5" },
                        React.createElement("div", { className: "col-lg-7 ml-3" }, reception_row.display_name),
                        React.createElement("div", { className: "col-sm-2 ml-3 text-center" },
                            React.createElement("a", { href: reception_list_search_url_all_count, className: "link-text" }, reception_row.all_count)),
                        React.createElement("div", { className: "col-sm-2 ml-3 text-center" },
                            React.createElement("a", { href: reception_list_search_url_stay_count, className: "link-text" }, reception_row.stay_count)))));
            })));
    };
    // 表示情報を取得
    var display_info = setDisplayInfo();
    return (React.createElement(React.Fragment, { key: 'reception_01' },
        React.createElement("div", { className: "title_block" }, header_message),
        React.createElement("div", { className: "container" },
            typeof error_message === 'undefined' ? (
            // 取得OK
            // 案件ステータス情報
            React.createElement(React.Fragment, { key: 'reception_02' },
                React.createElement("div", { className: "wrap", key: 'reception_03' }, display_info),
                React.createElement("div", { className: "py-3" },
                    React.createElement("fieldset", { className: "border border-primary notice_hw mx-2 my-3" },
                        React.createElement("legend", { className: "w-auto px-3 ml-3" }, "\u304A\u77E5\u3089\u305B"),
                        React.createElement("div", { className: "notice px-3 ml-3" }, news.map(function (line, index) { return (React.createElement("div", { key: index }, line)); })))))) : (
            // 取得NG
            React.createElement("div", { className: "alert alert-dange", role: "alert" }, error_message)),
            React.createElement(Row, { className: "ml-2" },
                React.createElement("a", { className: "btn-main-color btn btn-xl", onClick: handleClick }, "\u6848\u4EF6\u4E00\u89A7\u3078\u623B\u308B")),
            React.createElement(LoadingModal, { show: is_loading }))));
};
if (document.getElementById('dashboard-index')) {
    render(React.createElement(DashboardIndex, null), document.getElementById('dashboard-index'));
}
